import * as React from "react";
import NGAlert from "../../../newcomponents/alert";

const DeprecationBanner: React.FC = () => {
  return (
    <NGAlert
      type="warning"
      size="small"
      message="This UI is deprecated and will be removed soon."
    />
  );
};

export { DeprecationBanner };
